var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-input',_vm._g(_vm._b({ref:"inputRef",attrs:{"noWheel":"","type":"number","value":_vm.Value},on:{"change":_vm.onChange}},'b-input',_vm.$attrs,false),_vm.InputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }